/**
 * Formatea a texto legible el json que el backend guarda tal cual lo mando a
 * timbrar (CRM-3109, campo `json` de global_invoice_details), sin traducir
 * ni reinterpretar sus llaves -solo indentado.
 *
 * El backend a veces lo guarda doblemente serializado -un string que es, el
 * mismo, otro JSON string-; si el primer parse deja una cadena en vez de un
 * objeto, se intenta una segunda vuelta antes de darse por vencido.
 */
export const formatInvoiceJson = (json) => {
  // Si axios ya entrego el JSONB parseado, no hay nada que parsear.
  if (json && typeof json === "object") return JSON.stringify(json, null, 2);

  let parsed;
  try {
    parsed = JSON.parse(json);
    if (typeof parsed === "string") parsed = JSON.parse(parsed);
  } catch (error) {
    return null;
  }
  if (!parsed || typeof parsed !== "object") return null;

  return JSON.stringify(parsed, null, 2);
};
